import React from 'react';

import CompareDrawer from '../compare/components/compare-drawer';
import withPage, { loadGraphQLData } from '../page';
import HomePage from './components';

const HomeContainer = ({ templateKey, vanityUrl }) => {
    return (
        <>
            <HomePage templateKey={templateKey} vanityUrl={vanityUrl} />
            <CompareDrawer />
        </>
    );
};

export default {
    component: withPage(HomeContainer, {
        wrapperClassName: 'home-root',
        showWordCloud: true,
        useGraphQL: true,
        useV2: true,
        noProps: true,
        getOpenGraphData: components => {
            try {
                const { homeHeroBanner } = components || {};
                const [firstBanner] = homeHeroBanner || [];
                const { imageDesktopSrc, imageMobileSrc } = firstBanner || {};
                return {
                    image: imageMobileSrc || imageDesktopSrc,
                };
            } catch (e) {
                return {};
            }
        },
    }),
    loadData: loadGraphQLData,
};
